module.exports = __webpack_public_path__ + "static/media/no-issues.fe051389.svg";